import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import i18n from "../../../../constants/i18n";
import Et3Table from "../../../../core/et3-table";
import {
  AUDITOR_REPORT_ACTIONS_HEADERS,
  AUDITOR_TBW_EVENT_STATS_HEADERS
} from "../../../../constants/table-custom-headers/Auditor";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getReportActionsAnalyticsStore from "../../../../stores/auditor-store/report-actions-analytics-store";

const ReportActionsAnalyticsData = withLiteObserverAndTheme(() => {
  const reportActions = getReportActionsAnalyticsStore().reportActions.get();
  const tbwEventStats = getReportActionsAnalyticsStore().tbwEventStats.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={AUDITOR_REPORT_ACTIONS_HEADERS}
        rows={reportActions}
        title={i18n.get("REPORT_ACTIONS")}
        shouldBeFlagged={false}
        titleKey={"REPORT_ACTIONS"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={AUDITOR_TBW_EVENT_STATS_HEADERS}
        rows={tbwEventStats}
        title={i18n.get("REPORT_ACTION_REASONS")}
        shouldBeFlagged={false}
        titleKey={"REPORT_ACTION_REASONS"}
      />
    </React.Fragment>
  );
});

export default ReportActionsAnalyticsData;
